import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SvgIconService {
  private icons = new Map<string, string>();
  private ready$ = new ReplaySubject<void>(1);

  constructor(private http: HttpClient) {}

  /** Wird per APP_INITIALIZER beim App-Start aufgerufen. */
  load(): Observable<void> {
    return this.http.get<Record<string, string>>('assets/icons.json').pipe(
      tap(raw => {
        for (const [name, svg] of Object.entries(raw)) {
          this.icons.set(name, this.clean(svg));
        }
        this.ready$.next();
        this.ready$.complete();
      }),
      map(() => void 0)
    );
  }

  getCleanSvg(name: string): Observable<string> {
    return this.ready$.pipe(
      take(1),
      map(() => this.icons.get(name) ?? '')
    );
  }

  private clean(raw: string): string {
    return raw
      .replace(/\sdata-prefix="[^"]*"/g, '')
      .replace(/\sdata-icon="[^"]*"/g, '')
      .replace(/\sclass="svg-inline--fa[^"]*"/g, '')
      .replace(/fill="[^"]*"/g, 'fill="currentColor"')
      .replace(/stroke="[^"]*"/g, 'stroke="currentColor"');
  }
}
